/* eslint-disable react/prop-types */
// Bin.jsx
import React from 'react'
import High from './High'
import Low from './Low'

const BinDefault = ({ high = false, low = false, style }) => <Bin high={high} low={low} style={style} />

export default BinDefault

const Bin = ({ high, low, style }) => {
  const svgStyle = style || { fill: '#284047', stroke: '#284047' }
  return (
    <svg viewBox='0 0 75 75'>
      <g
        style={{
          transform: 'translate(19px, 2px) scale(0.2)',
        }}
      >
        <g
          fill='#000000'
          style={svgStyle}
        >
          <description>bin icon</description>
          <title>bin</title>
          <path d='m42.7 251.3 103.55-0.3 0.3 14.5-51 25.151-53-25z' />
          <rect x='43' y='55' width='21' height='198' />
          <rect x='74' y='55' width='49' height='197' />
          <rect x='126' y='55' width='20' height='196' />
          <rect x='43' y='54' width='102' height='5.75' />
          <path d='m68 55 26.21-27.272-10.61-0.1-40 26z' />
          <path d='m75.57 54.7 7.8-18.1 9.7-8.9 13.4-0.3 40 27z' />
          <g fill='none'>
            <g strokeWidth='5'>
              {/* <path d="m44.863 33.71c0.2-60.8 0.06-62.37 0.0-62" />
              <path d="m59.503 33.56c0.2-60.8 0.45-61 0.5-61" />
              <path d="m94.259 33.33c0.2-60.8 0.45-61 0.5-61" />
              <path d="m129.02 33.02c0.2-60.8 0.45-61 0.5-61" /> */}
              <path d='m45 327.8c0.2-62 0.1-62 0.1-62' />
              <path d='m143.88 327.8c0.2-62 0.1-62 0.1-62' />
              <path d='m47.149 327.31c12.478-60.819 12.468-60.652 12.468-60.652' />
              <path d='m94.496 325.33c35.419-60.819 35.782-61.052 35.782-61.052' />
              <path d='m58.934 325.33c35.419-60.819 35.782-61.052 35.782-61.052' />
              <path d='m129.87 324.95c-35.419-60.819-35.782-61.052-35.782-61.052' />
              <path d='m95.03 326.54c-35.419-60.819-35.782-61.052-35.782-61.052' />
              <path d='m129.83 325.97c12.478-60.819 12.754-61.052 12.754-61.052' />
              <path d='m59.499 327.4c-12.478-60.819-12.754-61.052-12.754-61.052' />
              <path d='m143.02 326.26c-12.478-60.819-12.754-61.052-12.754-61.052' />
            </g>
            <path
              strokeWidth='6.5'
              d='m42.336 324.72c103.43 0.22 103.9 0.2 103.9 0.2'
            />
          </g>
        </g>
      </g>
      {!!high && (
        <g id='high' transform='translate(130,110) scale(1.1)'>
          <High />
        </g>
      )}

      {!!low && (
        <g id='low' transform='translate(130,110) scale(1.1)'>
          <Low />
        </g>
      )}
    </svg>
  )
}
